import { AutocompleteInput } from '@/components/admin';
import { useGetList } from 'ra-core';

export const UQCAutocomplete = (props: any) => {
    const { data: uqcCodes, isLoading, error } = useGetList('uqc_codes', {
        pagination: { page: 1, perPage: 200 },
        sort: { field: 'code', order: 'ASC' },
    });

    console.log("[UQCAutocomplete] state v2:", { isLoading, error, count: uqcCodes?.length, codes: uqcCodes });

    const choices = (uqcCodes || []).map((u: any) => ({
        id: u.code,
        name: `${u.code} — ${u.description}`,
    }));

    return (
        <AutocompleteInput
            choices={choices}
            optionText="name"
            optionValue="id"
            inputText={(choice: any) => choice?.id || ''}
            matchSuggestion={(filter: string, choice: any) =>
                choice.id.toLowerCase().includes(filter.toLowerCase()) ||
                choice.name.toLowerCase().includes(filter.toLowerCase())
            }
            isLoading={isLoading}
            suggestionLimit={20}
            {...props}
        />
    );
};